import React from 'react'
import styled from '@emotion/styled'
import { device, space, useLockBodyScroll } from '@ticketswap/solar'
import Menu from './Menu'

const ScrollContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  padding: ${space[64]} ${space[16]} ${space[16]};
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    display: none;
  }
`

const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  background-color: white;

  &::before {
    content: '';
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    height: ${space[64]};
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  @media ${device.tablet} {
    display: none;
  }
`

function Overlay({ children, t, ...props }) {
  useLockBodyScroll()

  return (
    <Container>
      <ScrollContainer>
        <Menu t={t} {...props} />
      </ScrollContainer>
    </Container>
  )
}

export default Overlay
